import axios from 'axios';

import cfac22 from '../cfac22';

export default function campaignPolls(uid, campaignId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(cfac22('API_HOST_V2') + '/campaignPolls/all?campaignId=' + campaignId, {
        headers: {

          'Full-Url': window.location.href
        }, withCredentials: true
      }).
      then((result) => {
        resolve(result.data);
      }).
      catch((error) => {
        return reject(error.response.data);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
